import { graphql } from "lib/generated/app-service-gql";
import { useGraphQlQuery } from "../useGraphQlClient";

const aiChatQuery = graphql(`
  query aiChat($id: String!) {
    aiChat(id: $id) {
      conversationId
      messages {
        question
        answer
        sources {
          id
          type
          title
          url
          chunkNumber
          documentType
          filePath
          citationId
          isDeleted
          locations {
            pageNumber
            bbox {
              x
              y
              width
              height
            }
          }
        }
      }
    }
  }
`);

export function useAiChat(id: string) {
  const { data, ...rest } = useGraphQlQuery(["aiChat", id], aiChatQuery, [{ id }], {
    enabled: !!id,
  });

  return {
    data: {
      conversationId: data?.aiChat.conversationId ?? "",
      messages: data?.aiChat.messages ?? [],
    },
    ...rest,
  };
}
